import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { slugify } from "../helpers";
import VisibilitySensor from "react-visibility-sensor";

class ProductsTile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasAppeared: false
        };

        this.toggleActive = this.toggleActive.bind(this);
    }

    toggleActive(isVisible) {
        isVisible === true ? this.setState({ hasAppeared: true }) : "";
    }

    render() {
        const slug = this.props.products.name,
            type = this.props.type,
            sanitized = slugify(slug),
            url = `/${type}/${sanitized}/`;

        return (
            <VisibilitySensor onChange={this.toggleActive}>
                {({ isVisible }) => (
                    <Link
                        className={`tile__link ${
                            this.state.hasAppeared ? "is-visible" : ""
                        }`}
                        to={{ pathname: url }}
                        data-cta={`Search Tile: By Product: ${slug}`}
                    >
                        <article className="tile">
                            <div className="tile__content-container">
                                <figure className="tile__fig">
                                    <img
                                        src={this.props.products.icon}
                                        alt={this.props.products.name}
                                        className="tile__img"
                                    />
                                </figure>
                                <h3 className="tile__name">
                                    {this.props.products.name}
                                </h3>
                            </div>
                        </article>
                    </Link>
                )}
            </VisibilitySensor>
        );
    }
}

export default ProductsTile;



// WEBPACK FOOTER //
// ./src/components/ProductsTile.js